module.exports = __webpack_public_path__ + "static/media/13.0f016b72.jpg";